<template>
  <div class="">
    <CRow class="w-100">
      <CCol md="12" lg="12" sm="12" xs="12">
        <HomeMaintenceVue v-if="page == 'home'" @changePage="changePage" @setView="setView" />
        <RolesVue class="pt-3" v-if="page == 'roles'" @mtdBack="mtdBack" />
        <UsersVue class="pt-3" v-if="page == 'users'" @mtdBack="mtdBack" />
        <ClientVue class="pt-3" v-if="page == 'clients'" @mtdBack="mtdBack" />
        <CampusVue class="pt-3" v-if="page == 'campus'" @mtdBack="mtdBack" />
        <BoxVue class="pt-3" v-if="page == 'boxes'" @mtdBack="mtdBack" />
        <RecepcionistVue class="pt-3" v-if="page == 'recepcionists'" @mtdBack="mtdBack" />

        <ProductVue class="pt-3" v-if="page == 'products' && $store.getters.get_company.id != 5" @mtdBack="mtdBack" />
        <ProductCarbinoVue class="pt-3" v-if="page == 'products' && $store.getters.get_company.id == 5" @mtdBack="mtdBack" />

        <UnitsVue class="pt-3" v-if="page == 'units'" @mtdBack="mtdBack" />
        <CompanyVue class="pt-3" v-if="page == 'companies'" @mtdBack="mtdBack" />
        <DocumentTypeVue class="pt-3" v-if="page == 'document_type'" @mtdBack="mtdBack" />
        <MethodPaymentVue class="pt-3" v-if="page == 'method_payment'" @mtdBack="mtdBack" />

        <ProveiderVue class="pt-3" v-if="page == 'provider' &&  $store.getters.get_company.id != 5" @mtdBack="mtdBack" />
        <ProveiderCarbinoVue class="pt-3" v-if="page == 'provider' &&  $store.getters.get_company.id == 5" @mtdBack="mtdBack" />
        
        <Personal class="pt-3" v-if="page == 'personal'" @mtdBack="mtdBack"/>
        <Projects class="pt-3" v-if="page == 'projects'" @mtdBack="mtdBack"/>
        <AlmacenVue class="pt-3" v-if="page == 'almacen'" @mtdBack="mtdBack" />
        <InputVue class="pt-3" v-if="page == 'inputs'" @mtdBack="mtdBack" />
        <KitsVue class="pt-3" v-if="page == 'kits'" @mtdBack="mtdBack" />

        <BrandCarbinoVue class="pt-3" v-if="page == 'brand'" @mtdBack="mtdBack" />
        <ModelsCarbinoVue class="pt-3" v-if="page == 'model'" @mtdBack="mtdBack" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BoxVue from "../../components/maintenance/demo/Box.vue";
import CampusVue from "../../components/maintenance/demo/Campus.vue";
import ClientVue from '../../components/maintenance/demo/Client.vue';
import RecepcionistVue from "../../components/maintenance/demo/Recepcionist.vue";
import HomeMaintenceVue from "../../components/maintenance/demo/home.vue";
import ProductVue from "../../components/maintenance/aq/Product.vue"
import UnitsVue from "../../components/maintenance/demo/Unit.vue"
import RolesVue from "../access/roles.vue";
import UsersVue from "../access/users.vue";
import CompanyVue from "../../components/maintenance/demo/Company.vue";
import DocumentTypeVue from "../../components/maintenance/demo/DocumentType.vue";
import MethodPaymentVue from "../../components/maintenance/demo/MethodPayment.vue";
import ProveiderVue from "../../components/maintenance/demo/Proveider.vue";
import Personal from "../../components/maintenance/demo/personal/Personal.vue";
import Projects from "../../components/maintenance/demo/Projects.vue";
import AlmacenVue from "../../components/maintenance/demo/Almacen.vue";
import InputVue from '../../components/maintenance/aq/Input.vue';
import KitsVue from '../../components/maintenance/aq/Kits.vue';
import ProductCarbinoVue from '../../components/maintenance/carbino/Product.vue'
import BrandCarbinoVue from '../../components/maintenance/carbino/Brand.vue'
import ModelsCarbinoVue from '../../components/maintenance/carbino/Models.vue'
import ProveiderCarbinoVue from '../../components/maintenance/carbino/Provider.vue'

export default {
  components: {
    HomeMaintenceVue,
    RolesVue,
    UsersVue,
    CampusVue,
    BoxVue,
    RecepcionistVue, 
    ProductVue, 
    UnitsVue, 
    CompanyVue, 
    DocumentTypeVue, 
    MethodPaymentVue,
    ProveiderVue,
    ClientVue,
    Personal,
    Projects,
    AlmacenVue,
    InputVue,
    KitsVue,
    ProductCarbinoVue,
    BrandCarbinoVue,
    ModelsCarbinoVue,
    ProveiderCarbinoVue
  },
  data() {
    return {
      page: "home",
    };
  },
  methods: {
    changePage: function (page) {
      this.page = page;
    },
    mtdBack: function () {
      this.page = 'home';
    },
    setView: function(){
      this.$emit('setView', 'home')
    }
  },
};
</script>
